var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { cloneDeep } from 'lodash';
import Component from 'vue-class-component';
import GlobalVue from "../../../globalVue";
import { billDefaultDate } from "../../../helper/defaultDate";
import ShopAfterSalesService from '../../../api/ShopAfterSalesService';
import { EPurOrderStatus } from "../../../enum/EStatus";
import { Prop, Watch } from 'vue-property-decorator';
import Add from './../Add.vue';
import { mapGetters } from "vuex";
function getDefaultFormData() {
    return {
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        status: -1,
        keyword_type: 1,
        keyword: '',
        refund_order_type: '',
    };
}
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.purOrderStatus = EPurOrderStatus;
        _this.formData = getDefaultFormData();
        _this.type = [
            {
                id: 1,
                label: "订单号"
            },
            {
                id: 2,
                label: "客户"
            },
            {
                id: 3,
                label: "售后工单"
            },
            {
                id: 4,
                label: '送货单号'
            }
        ];
        _this.options = [
            {
                id: -1,
                label: "全部状态"
            },
            {
                id: 1,
                label: "待确认"
            },
            {
                id: 2,
                label: "已确认"
            },
            {
                id: 3,
                label: "已驳回"
            },
            {
                id: 4,
                label: "已废弃"
            },
        ];
        _this.typeOptions = [];
        return _this;
    }
    BillHeader.prototype.watchSelectRows = function (newValue, oldValue) {
        console.log(newValue);
    };
    BillHeader.prototype.created = function () {
        if (this.status) {
            this.formData.status = parseInt(this.status.toString());
        }
        ;
        this.service = ShopAfterSalesService.getInstance();
        this.getRefundTypeOption();
    };
    BillHeader.prototype.mounted = function () {
        this.search();
    };
    BillHeader.prototype.getRefundTypeOption = function () {
        var _this = this;
        this.service.getRefundTypeOption().then(function (res) {
            var DATA = res.data || { data: [] };
            var typeOptions = Array.isArray(DATA.data) ? DATA.data : [];
            _this.typeOptions = [{ id: '', name: "全部类型" }].concat(typeOptions);
        });
    };
    BillHeader.prototype.search = function () {
        var params = cloneDeep(this.formData);
        if (params.keyword_type === 4) {
            params.delivery_order_code = params.keyword;
            params.keyword = '';
        }
        this.$emit('search', __assign({}, params));
    };
    BillHeader.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    BillHeader.prototype.syncOrders = function () {
        var params = cloneDeep(this.formData);
        if (params.keyword_type === 4) {
            params.delivery_order_code = params.keyword;
            params.keyword = '';
        }
        this.$emit('syncOrders', __assign({}, params));
    };
    BillHeader.prototype.addRefundOrder = function () {
        console.log('添加');
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '新增售后工单',
            showExist: true,
            name: 'add_refund_order',
            cprops: {
                rowId: '0',
                opener: this,
                Root_PageAuth: this.Root_PageAuth,
            }
        });
    };
    BillHeader.prototype.delRefundOrder = function () {
        this.$emit('delRefundOrder');
    };
    __decorate([
        Prop({
            default: null,
            type: Number || String || null
        })
    ], BillHeader.prototype, "status", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
            type: [Array || undefined]
        })
    ], BillHeader.prototype, "selectRows", void 0);
    __decorate([
        Watch('selectRows', { immediate: true })
    ], BillHeader.prototype, "watchSelectRows", null);
    BillHeader = __decorate([
        Component({
            components: {}
        }),
        Component({
            computed: __assign({}, mapGetters({
                ediStatus: 'ediStatus'
            })),
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
